module.exports = __webpack_public_path__ + "src/assets/img/Chrysemys_picta15_small.6c087b85.jpg";